<template>
  <div>
    <h1>{{$t("main.login.login")}}</h1>
    <div id="firebaseui-auth-container"></div>
    <div id="loader">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{$t("main.login.loading")}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import "firebaseui/dist/firebaseui.css";
import { auth } from "@/plugins/firebase";
var firebase = require("firebase");
var firebaseui = require("firebaseui");
var ui = new firebaseui.auth.AuthUI(auth);
var uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function(authResult, redirectUrl) {
      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
      // or whether we leave that to developer to handle.
      return true;
    },
    uiShown: function() {
      // The widget is rendered.
      // Hide the loader.
      document.getElementById("loader").style.display = "none";
    }
  },
  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  signInFlow: "popup",
  signInSuccessUrl: "/home",
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.PhoneAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: "/license",
  // Privacy policy url.
  privacyPolicyUrl: "/termsofuse"
};
import { mapState } from "vuex";
export default {
  name: "Login",
  computed: mapState("auth", ["user"]),
  watch: {
    user: function(user) {
      if (user) this.$router.push("/home");
    }
  },
  mounted: function() {
    if (!this.user) ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style>
</style>